//@flow

export const E_INVOICE_FORM_FIELDS = {
  enabled: 'enabled',
  documentType: 'documentType',
  enableAutoEmission: 'enableAutoEmission',
  companyName: 'companyName',
  ruc: 'ruc',
  address: 'address',
  admin1: 'admin1',
  admin2: 'admin2',
  admin3: 'admin3',
};
